module.exports = __webpack_public_path__ + "img/selected2-min.194934b1.png";